// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span[data-v-763f43c5] strong{font-weight:400}.party-size[data-v-763f43c5]{align-items:flex-start;display:flex;flex-direction:row;flex-wrap:wrap}.adults[data-v-763f43c5]{margin-right:.2em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
